import config from 'config';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { commonActions } from 'srcReact/components';
import { formatLastUpdateDate, getDateFormat3 } from 'srcReact/helpers/datetimeHelper';

const SuccessfulUpdatePopin = (props) => {
	const { t, type, selectedPlan, subscription, update_infos } = props;

	const handleClosePopin = () => {
		const { closePopin } = props;

		window.history.replaceState(null, null, window.location.pathname);
		closePopin();
	};

	const isDirectDowngrade = () => {
		return update_infos && update_infos.type === 'immediate';
	};

	const getImageName = () => {
		switch (type) {
			case 'upgrade':
				return 'upgrade-successful';
			case 'downgrade':
				return 'pending-invites';

			default:
				return '';
		}
	};

	const getTitle = () => {
		switch (type) {
			case 'upgrade':
				return t('billing.popin.ugradeSuccessful.title');
			case 'downgrade':
				if (isDirectDowngrade()) {
					return t('billing.popin.downgradeSuccessful.directDowngradeTitle');
				}
				return t('billing.popin.downgradeSuccessful.title');
			default:
				return '';
		}
	};

	const getText = () => {
		switch (type) {
			case 'downgrade':
				const currentPlan = subscription.plan.name;
				const newPlan = selectedPlan.name;
				const billingDate = subscription.organization_subscription.pending_plan_update_term;
				if (isDirectDowngrade()) {
					return update_infos && update_infos.message ? update_infos.message : '';
				}
				return t('billing.popin.downgradeSuccessful.text', {
					newPlanName: newPlan,
					billingDate: formatLastUpdateDate(billingDate, getDateFormat3(),t),
					currentPlanName: currentPlan
				});
			default:
				return '';
		}
	};

	const imageName = getImageName();
	return (
		<Fragment>
			<div className="popin-content--image">
				<img src={`${config.assetUrl}/images/${imageName}.svg`} alt="process" />
			</div>
			<h2 className="popin-content--title popin-content--title-down">{getTitle()}</h2>
			<div className="popin-content--text" dangerouslySetInnerHTML={{ __html: getText() }} />
			<div className="popin-content--controllers with-link">
				<button type="button" className="button is-primary" onClick={() => handleClosePopin()}>
					{t('billing.popin.choosePlanRestriction.btnPrimary')}
				</button>
			</div>
		</Fragment>
	);
};

const actionCreators = {
	closePopin: commonActions.closePopin
};

const ExtendedComponent = withTranslation('common')(SuccessfulUpdatePopin);
const connectedSuccessfulUpdatePopin = connect(null, actionCreators)(ExtendedComponent);

export { connectedSuccessfulUpdatePopin as SuccessfulUpdatePopin };
